import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { DeviceDetailsPageComponent } from './device-details-page.component';

const routes: Routes = [
  {
    path: 'device-details',
    data: { name: 'Device Details', isTab: false },
    component: DeviceDetailsPageComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DeviceDetailsPageRoutingModule {}
